import { omit } from 'lodash'

export const auctionConventer = {
  toFirestore(data) {
    return omit(data, ['id'])
  },
  fromFirestore(doc, options) {
    const data = doc.data(options)

    return {
      ...data,
      createdAt: data?.createdAt?.toDate() || null,
      startDatePreBid: data?.startDatePreBid?.toDate?.() || data?.startDatePreBid,
      id: doc.id,
    }
  },
}
